import React from 'react';
import { Box, Botao, Alerta, TipoAlerta, Form, CampoTexto, Combo, TipoBotao } from "@intechprev/componentes-web";
import { BancoAgEntidade, WebRecadParticipanteDadosEntidade } from '../../entidades';
import { ArquivoUpload, ArquivoUploadItem } from './ArquivoUpload';
import { Passos } from '.';
import { RecadastramentoService } from '../../services';

interface Props {
  setDadosPasso: any;
  Dados: any;
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  HouveAlteracao: any;
  ListaArquivo: Array<ArquivoUploadItem>;
  setListaArquivo: any;
  Avancar: () => void;
  Voltar: () => void;
  NumeroPassoAtual: number;
}

interface State {
  Banco: string;
  Agencia: string;
  Conta: string;
  OpcoesBanco: BancoAgEntidade[];
}

export class Passo5 extends React.Component<Props, State> {

  private form = React.createRef<Form>();
  private alerta = React.createRef<Alerta>();
  private arquivo = React.createRef<ArquivoUpload>();

  constructor(props: Props) {
    super(props);

    this.state = {
      Banco: "",
      Agencia: "",
      Conta: "",
      OpcoesBanco: []
    }
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);
      // const NumeroPassoAlternativo = this.NaoPensionista() ? "5" : "4";

      const bancos = await RecadastramentoService.BuscarListaBanco();

      this.setState({
        Banco: this.props.Dados.Banco || this.props.DadosOriginais.NUM_BANCO || "",
        Agencia: this.props.Dados.Agencia || this.props.DadosOriginais.NUM_AGENCIA || "",
        Conta: this.props.Dados.Conta || this.props.DadosOriginais.NUM_CONTA || "",
        OpcoesBanco: bancos
      });
    }
    catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  }

  // ObrigatoriedadeCampos = () => {
  //   return (this.state.Banco !== ""
  //     || this.state.Agencia !== ""
  //     || this.state.Conta !== "");
  // }

  CompararDados = () => {
    return (
      this.props.HouveAlteracao(this.props.DadosOriginais.NUM_BANCO, this.state.Banco)
      || this.props.HouveAlteracao(this.props.DadosOriginais.NUM_AGENCIA, this.state.Agencia)
      || this.props.HouveAlteracao(this.props.DadosOriginais.NUM_CONTA, this.state.Conta)
    );
  }

  SalvarDados = () => {
    const d = {
      Banco: this.state.Banco,
      Agencia: this.state.Agencia,
      Conta: this.state.Conta
    };
    this.props.setDadosPasso(Passos.Passo5, d);
  }

  Voltar = () => {
    this.SalvarDados();
    this.props.Voltar();
  }

  Proximo = async (): Promise<any> => {
    try {
      await this.alerta.current.limparErros();
      await this.form.current.validar();
      this.arquivo.current.MostrarAviso(false);

      if (this.form.current.isValido()) {

        // if (/\D/gm.test(this.state.Agencia)) {
        //   await this.alerta.current.adicionarErro("Campo 'Agência (sem o Dígito)' é apenas numérico.");
        //   return null;
        // }

        if (this.PrecisaEnvarArquivo()) {
          await this.alerta.current.adicionarErro("O envio de pelo menos um documento é obrigatório.");
          this.arquivo.current.MostrarAviso(true);
          return null;
        }
        this.SalvarDados();

        this.props.Avancar();
      }
    }
    catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  }

  PrecisaEnvarArquivo = () => {
    const ListaArquivoPasso = this.props.ListaArquivo.filter(arquivo => arquivo.Passo === Passos.Passo5);

    return (this.CompararDados() && ListaArquivoPasso.length === 0);
  }

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Dados Bancários`}>
        <Form ref={this.form}>
          <Combo
            contexto={this}
            titulo={"Número do Banco"}
            nome={"Banco"}
            valor={this.state.Banco}
            opcoes={this.state.OpcoesBanco}
            nomeMembro={"DESC_BCO_AG"}
            valorMembro={"COD_BANCO"}
            desabilitado
          />

          <CampoTexto
            contexto={this}
            nome={"Agencia"}
            titulo={"Agência (com o Dígito)"}
            desabilitado
            max={5}
            valor={this.state.Agencia}
          />

          <CampoTexto
            contexto={this}
            nome={"Conta"}
            titulo={"Conta Corrente (com o DV)"}
            desabilitado
            valor={this.state.Conta}
            max={15}
          />

          <Alerta
            tipo={TipoAlerta.danger}
            ref={this.alerta}
            padraoFormulario
          />

          <ArquivoUpload
            ListaArquivo={this.props.ListaArquivo}
            PassoAtual={Passos.Passo5}
            setListaArquivo={this.props.setListaArquivo}
            texto={"Em caso de alteração de dados bancários será necessário enviar comprovante, como por exemplo imagem de: topo do extrato bancário, cartão bancário ou tela inicial do aplicativo do banco. Lembramos que a PREVIRB atua para pagamento de benefícios apenas com o Banco do Brasil e Banco Santander."}
            ref={this.arquivo}
          />

          <Botao
            onClick={this.Voltar}
            titulo={"Voltar"}
            className={"m-2"}
            tipo={TipoBotao.light}
            icone={"angle-double-left"}
            iconeDireita
          />

          <Botao
            onClick={this.Proximo}
            titulo={"Continuar"}
            icone={"angle-double-right"}
            iconeDireita
          />
        </Form>
      </Box>
    );
  }
}